import Vue from "vue";
import App from "./App.vue";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import vuetify from "@/plugins/vuetify";
import { router } from "@/plugins/router";
import i18n from "@/plugins/i18n";
import store from "@/plugins/store";
import idsrvAuth from './Auth'
import VueAutosuggest from "vue-autosuggest";
Vue.use(VueAutosuggest);

require("./styles/main.scss");

import * as VueGoogleMaps from "vue2-google-maps";

import VueSession from "vue-session";
import Global from '../src/_helpers/mixin';
import VModal from 'vue-js-modal';
Vue.use(VModal);

import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
var VueCookie = require('vue-cookie');
// Tell Vue to use the plugin
Vue.use(VueCookie);

Vue.use(VueTelInput);

Vue.mixin(Global);
// Vue.component('datetime', Datetime);

Vue.use(VueSession);

// import { configureFakeBackend } from "./_helpers/fake-backend";
// configureFakeBackend();

Vue.use(BootstrapVue);
Vue.use(VueGoogleMaps, {
  load: {
    key: `${process.env.VUE_APP_GOOGLE_KEY_API}`,
    libraries: "places"
  }
});

import HotelDatePicker from "vue-hotel-datepicker";
Vue.component("HotelDatePicker", HotelDatePicker);

import { CoolSelectPlugin } from "vue-cool-select";
Vue.use(CoolSelectPlugin);

Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();
import "./plugins/vuetify-number.js";
new Vue({
  router,
  i18n,
  vuetify,
  store,
  // fontAwesome,
  idsrvAuth,
  render: h => h(App)
}).$mount("#app");
